<div class="pr-xlarge-t mr-large-b">
  <fcom-quick-links
    [links]="links$ | async"
    [showBorder]="false"
    [showCompact]="true"
    (clickLink)="clickLink($event)"
  />
</div>
